import React from "react"
import styled, { css } from "styled-components"
import { colors } from "buoy-theme"
import { AuthForm } from "../../auth/components/AuthForm"
import { Paragraph, HeadingTwo, Link, Button, Checklist } from "buoy-core"
import Check from "../../completion/images/Check"

const FormWrapper = styled.div`
  padding: 24px 0;

  ${props => props.last ? css`
    border-bottom: none;
  ` : css`
    border-bottom: 1px solid ${colors.neutralLighter};
  `};
`

const CheckListWrapper = styled.div`
  margin: 16px 0 32px;
`

const SubmitButton = styled(Button)`
  width: 100%;
  margin: 6px 0;
`

const FormLink = styled(Link)`
  margin-top: 8px;
`

const Heading = styled(HeadingTwo)`
  font-size: 30px;
  margin-bottom: 12px;
`

const SuccessMessageContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
`

const SuccessParagraph = styled(Paragraph)`
  margin-bottom: 12px;
`

const EmailSubmittedSuccessMessage = ({ email }) => (
  <SuccessMessageContainer>
    <SuccessParagraph color="primary">
      Email Submitted!
    </SuccessParagraph>
    <Check
      color="primary"
      strokeWidth="1.5"
      margin="0 0 16px 8px" />
    <SuccessParagraph>
      {`You’re almost done! A verification message will be sent to ${email}. Check your email and follow the link to finish setting up your Buoy account.`}
    </SuccessParagraph>
  </SuccessMessageContainer>
)

const Form = ({
  onSubmit,
  toggleFormDisplay,
  heading,
  mainText,
  buttonText,
  links,
  checkList,
  showForm,
  last,
  title,
  email,
  authError,
  onEmailChange,
  disableAuthForm,
  disabled
}) => (
  <FormWrapper last={last}>
    <Heading>{heading}</Heading>
    {showForm ? (
      <React.Fragment>
        {mainText && <Paragraph>{mainText}</Paragraph>}
        {checkList &&
          <CheckListWrapper>
            <Checklist items={checkList} />
          </CheckListWrapper>
        }
        {title !== "login" && authError.status === "ok" ? (
          <EmailSubmittedSuccessMessage email={email} />
        ) : (
          <AuthForm
            dashboard
            showEmail
            email={email}
            disableSubmit={disabled}
            authError={authError}
            onSubmit={onSubmit}
            onEmailChange={onEmailChange}
            showPass={title === "login"}
            submitText={title === "login" ? "Log in" : "Create account"}
          />
        )}
        {links && links.map(l => (
          <FormLink key={l.text} href={disableAuthForm ? null : l.path}>{l.text}</FormLink>
        ))}
      </React.Fragment>
    ) : (
      buttonText &&
        <SubmitButton onClick={() => toggleFormDisplay()}>
          {buttonText}
        </SubmitButton>
    )}
  </FormWrapper>
)

const AuthFormWrapper = ({
  showLogin,
  disabled,
  email,
  authError,
  onSubmit,
  formConfig,
  toggleFormDisplay,
  onEmailChange,
  disableAuthForm,
}) => (
  Object.keys(formConfig).map((key, i) => (
    <Form
      showForm={(showLogin && key === 'login') || (!showLogin && key !== 'login')}
      key={key}
      last={Object.keys(formConfig).length -1 === i}
      title={key}
      disableAuthForm={disableAuthForm}
      disabled={disabled}
      email={email}
      authError={authError}
      onEmailChange={onEmailChange}
      toggleFormDisplay={toggleFormDisplay}
      onSubmit={onSubmit}
      {...formConfig[key]}
    />
  ))
)

export { AuthFormWrapper as default }


// WEBPACK FOOTER //
// ./assets/dashboard/components/AuthForm.js